import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/icon_HiOutlineCalendar.svg'


const _hoisted_1 = { class: "row col q-pb-md" }
const _hoisted_2 = { class: "row col q-pb-md" }
const _hoisted_3 = { class: "row col q-pb-md" }
const _hoisted_4 = { class: "row col q-pb-md" }
const _hoisted_5 = { class: "row col q-pb-md" }
const _hoisted_6 = { class: "row col q-pb-md" }
const _hoisted_7 = { class: "row col q-pb-md" }
const _hoisted_8 = { class: "row col q-pb-md" }
const _hoisted_9 = { class: "q-pb-md" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { style: {"width":"160px"} }
const _hoisted_12 = { class: "row items-center justify-end" }
const _hoisted_13 = { style: {"width":"160px"} }
const _hoisted_14 = { class: "row items-center justify-end" }
const _hoisted_15 = {
  class: "row fit flex no-wrap justify-between q-pb-xs",
  style: {"width":"100%"}
}
const _hoisted_16 = { class: "q-pr-sm" }
const _hoisted_17 = { class: "col col-grow q-pl-sm" }

import ButtonCloseModal from '@/components/ButtonCloseModal.vue'
import { EnumButtonSizes } from '@/enums/enums'
import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useRedeSubredeStore } from '@/stores/redeSubredeStore'
import { ref, computed, onMounted } from 'vue'
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalFilterConsulta',
  setup(__props) {

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const redeSubredeStore = useRedeSubredeStore()

const qPopupProxyStartDate: { value: QPopupProxy | null } = ref(null)
const qPopupProxyEndDate: { value: QPopupProxy | null } = ref(null)

// ✅ Carrega subredes ao abrir o modal
onMounted(async () => {
  if (!redeSubredeStore.subredes.length) {
    await redeSubredeStore.carregarSubredes()
  }
})

// ✅ Filtra apenas subredes da rede 10 (Banco 24H)
const optionsSubrede = computed(() =>
  redeSubredeStore.subredes.filter(s => s.codRedeAutoAtndto === 10)
)

const optionsStatus = computed(() => Object.values(CONST_INSTITUTIONAL_STATUS))

const optionsTipo = [
  { label: 'Telas Iniciais', value: 'INICIAL' },
  { label: 'Telas de Aguarde', value: 'AGUARDE' },
  { label: 'Tela de Abertura', value: 'ABERTURA' },
]

const optionsPerfil = ['Banco24Horas', 'ATM Manager']

const onClearFilterBtnClick = () => {
  institutionalStore.resetInstitutionalFilter()
}

const formatDateToApi = (date?: string) => {
  if (!date || !date.includes('/')) return date
  const [day, month, year] = date.split('/')
  return `${year}-${month}-${day}` // ✅ DD/MM/YYYY → YYYY-MM-DD
}


const onFetchInstitutionalBtnClick = async () => {
  pagesUtilStore.showLoadingModal = true

  institutionalStore.institutionalFilter.dt_ini_vigencia = formatDateToApi(
    institutionalStore.institutionalFilter.dt_ini_vigencia
  )
  institutionalStore.institutionalFilter.dt_fim_vigencia = formatDateToApi(
    institutionalStore.institutionalFilter.dt_fim_vigencia
  )

  await institutionalStore.fetchInstitutionalScreens()
  pagesUtilStore.showModalFilterInstitutional = false
  pagesUtilStore.showLoadingModal = false
}

const startDateDefaultYearMonth = computed(() => {
  const now = new Date()
  now.setHours(0, 0, 0, 0)
  const formatter = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
  return formatter.format(now).split('/').reverse().join('/').substring(0, 7)
})

const optionsGranularidade = [
  { label: 'Por PC', value: 'Por PC' },
  { label: 'Por Subrede', value: 'Por Subrede' },
  { label: 'Por Rede', value: 'Por Rede' },
]



return (_ctx: any,_cache: any) => {
  const _component_c_modal_title = _resolveComponent("c-modal-title")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_c_q_separator = _resolveComponent("c-q-separator")!
  const _component_c_q_btn = _resolveComponent("c-q-btn")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_dialog, {
      modelValue: _unref(pagesUtilStore).showModalFilterInstitutional,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(pagesUtilStore).showModalFilterInstitutional) = $event)),
      "no-backdrop-dismiss": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: "midia-app-padding-modal",
          style: {"width":"500px","max-width":"80vw"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_c_modal_title, {
                propModalTitle: "Telas Institucionais",
                propModalDescription: "Consulte e gerencie os cadastros de Telas Institucionais"
              }),
              _createElementVNode("div", _hoisted_1, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "row q-pb-xs" }, [
                  _createElementVNode("span", { class: "midia-app-label-modal-sm" }, "Nome do Cadastro")
                ], -1)),
                _createVNode(_component_q_input, {
                  modelValue: _unref(institutionalStore).institutionalFilter.nome,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(institutionalStore).institutionalFilter.nome) = $event)),
                  outlined: "",
                  dense: "",
                  color: "globalAppPrimaryColor",
                  style: {"width":"100%"},
                  placeholder: "Digite o nome do cadastro"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "row q-pb-xs" }, [
                  _createElementVNode("span", { class: "midia-app-label-modal-sm" }, "Status")
                ], -1)),
                _createVNode(_component_q_select, {
                  modelValue: _unref(institutionalStore).institutionalFilter.status,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(institutionalStore).institutionalFilter.status) = $event)),
                  options: optionsStatus.value,
                  outlined: "",
                  "option-label": "description",
                  "option-value": "id",
                  "map-options": "",
                  "emit-value": "",
                  dense: "",
                  clearable: "",
                  color: "globalAppPrimaryColor",
                  style: {"width":"100%"},
                  "label-slot": !_unref(institutionalStore).institutionalFilter.status
                }, {
                  label: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("span", { class: "midia-app-placeholder-md" }, "Selecione um Status", -1)
                  ]))]),
                  option: _withCtx(({ itemProps, opt }) => [
                    _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(itemProps)), {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(opt.description), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "label-slot"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "row q-pb-xs" }, [
                  _createElementVNode("span", { class: "midia-app-label-modal-sm" }, "Tipo")
                ], -1)),
                _createVNode(_component_q_select, {
                  modelValue: _unref(institutionalStore).institutionalFilter.telasCadastradas,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(institutionalStore).institutionalFilter.telasCadastradas) = $event)),
                  options: optionsTipo,
                  outlined: "",
                  "option-label": "label",
                  "option-value": "value",
                  "map-options": "",
                  "emit-value": "",
                  dense: "",
                  clearable: "",
                  color: "globalAppPrimaryColor",
                  style: {"width":"100%"},
                  "label-slot": !_unref(institutionalStore).institutionalFilter.tipo
                }, {
                  label: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("span", { class: "midia-app-placeholder-md" }, "Selecione um Tipo", -1)
                  ]))]),
                  _: 1
                }, 8, ["modelValue", "label-slot"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "row q-pb-xs" }, [
                  _createElementVNode("span", { class: "midia-app-label-modal-sm" }, "Perfil")
                ], -1)),
                _createVNode(_component_q_select, {
                  modelValue: _unref(institutionalStore).institutionalFilter.perfil,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(institutionalStore).institutionalFilter.perfil) = $event)),
                  options: optionsPerfil,
                  outlined: "",
                  dense: "",
                  clearable: "",
                  color: "globalAppPrimaryColor",
                  style: {"width":"100%"},
                  "label-slot": !_unref(institutionalStore).institutionalFilter.perfil
                }, {
                  label: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("span", { class: "midia-app-placeholder-md" }, "Selecione um Perfil", -1)
                  ]))]),
                  _: 1
                }, 8, ["modelValue", "label-slot"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "row q-pb-xs" }, [
                  _createElementVNode("span", { class: "midia-app-label-modal-sm" }, "Rede")
                ], -1)),
                _createVNode(_component_q_input, {
                  "model-value": "Banco24Horas",
                  outlined: "",
                  dense: "",
                  readonly: "",
                  color: "globalAppPrimaryColor",
                  style: {"width":"100%"}
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "row q-pb-xs" }, [
                  _createElementVNode("span", { class: "midia-app-label-modal-sm" }, "Subrede ")
                ], -1)),
                _createVNode(_component_q_select, {
                  modelValue: _unref(institutionalStore).institutionalFilter.codSubrede,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(institutionalStore).institutionalFilter.codSubrede) = $event)),
                  options: optionsSubrede.value,
                  outlined: "",
                  "option-label": "nomSubredeAutoAtndto",
                  "option-value": "codSubredeAutoAtndto",
                  "map-options": "",
                  "emit-value": "",
                  dense: "",
                  clearable: "",
                  color: "globalAppPrimaryColor",
                  style: {"width":"100%"},
                  "label-slot": !_unref(institutionalStore).institutionalFilter.codSubrede
                }, {
                  label: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("span", { class: "midia-app-placeholder-md" }, "Selecione uma Subrede", -1)
                  ]))]),
                  _: 1
                }, 8, ["modelValue", "options", "label-slot"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "row q-pb-xs" }, [
                  _createElementVNode("span", { class: "midia-app-label-modal-sm" }, "Código do PC")
                ], -1)),
                _createVNode(_component_q_input, {
                  modelValue: _unref(institutionalStore).institutionalFilter.codPc,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(institutionalStore).institutionalFilter.codPc) = $event)),
                  outlined: "",
                  dense: "",
                  color: "globalAppPrimaryColor",
                  style: {"width":"100%"},
                  placeholder: "Digite o código do PC",
                  type: "number"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "row q-pb-xs" }, [
                  _createElementVNode("span", { class: "midia-app-label-modal-sm" }, "Granularidade")
                ], -1)),
                _createVNode(_component_q_select, {
                  modelValue: _unref(institutionalStore).institutionalFilter.granularidade,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(institutionalStore).institutionalFilter.granularidade) = $event)),
                  options: optionsGranularidade,
                  outlined: "",
                  "option-label": "label",
                  "option-value": "value",
                  "map-options": "",
                  "emit-value": "",
                  dense: "",
                  clearable: "",
                  color: "globalAppPrimaryColor",
                  style: {"width":"100%"},
                  "label-slot": !_unref(institutionalStore).institutionalFilter.granularidade
                }, {
                  label: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createElementVNode("span", { class: "midia-app-placeholder-md" }, "Selecione a Granularidade", -1)
                  ]))]),
                  _: 1
                }, 8, ["modelValue", "label-slot"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "row q-pb-xs" }, [
                  _createElementVNode("span", { class: "midia-app-label-modal-sm" }, "Período")
                ], -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_q_input, {
                      style: {"outline":"1px solid var(--globalAppSecondaryColor2)"},
                      modelValue: _unref(institutionalStore).institutionalFilter.dt_ini_vigencia,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(institutionalStore).institutionalFilter.dt_ini_vigencia) = $event)),
                      "bg-color": "globalAppDefaultBackgroundColor",
                      borderless: "",
                      dense: "",
                      readonly: "",
                      "input-class": "midia-app-content-lg"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          class: "cursor-pointer q-pa-sm q-mr-sm",
                          style: {"background":"var(--globalAppPrimaryColor)"}
                        }, {
                          default: _withCtx(() => [
                            _cache[25] || (_cache[25] = _createElementVNode("img", {
                              class: "svg-icon",
                              src: _imports_0
                            }, null, -1)),
                            _createVNode(_unref(QPopupProxy), {
                              ref_key: "qPopupProxyStartDate",
                              ref: qPopupProxyStartDate,
                              cover: "",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_date, {
                                  modelValue: _unref(institutionalStore).institutionalFilter.dt_ini_vigencia,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(institutionalStore).institutionalFilter.dt_ini_vigencia) = $event)),
                                  mask: "DD/MM/YYYY",
                                  minimal: "",
                                  "default-year-month": startDateDefaultYearMonth.value,
                                  color: "globalAppPrimaryColor"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_12, [
                                      _createVNode(ButtonCloseModal)
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "default-year-month"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("span", { class: "midia-app-label-lg q-px-md" }, "até", -1)),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_q_input, {
                      style: {"outline":"1px solid var(--globalAppSecondaryColor2)"},
                      modelValue: _unref(institutionalStore).institutionalFilter.dt_fim_vigencia,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(institutionalStore).institutionalFilter.dt_fim_vigencia) = $event)),
                      "bg-color": "globalAppDefaultBackgroundColor",
                      borderless: "",
                      dense: "",
                      readonly: "",
                      "input-class": "midia-app-content-lg"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          class: "cursor-pointer q-pa-sm q-mr-sm",
                          style: {"background":"var(--globalAppPrimaryColor)"}
                        }, {
                          default: _withCtx(() => [
                            _cache[26] || (_cache[26] = _createElementVNode("img", {
                              class: "svg-icon",
                              src: _imports_0
                            }, null, -1)),
                            _createVNode(_unref(QPopupProxy), {
                              ref_key: "qPopupProxyEndDate",
                              ref: qPopupProxyEndDate,
                              cover: "",
                              "transition-show": "scale",
                              "transition-hide": "scale"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_date, {
                                  modelValue: _unref(institutionalStore).institutionalFilter.dt_fim_vigencia,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(institutionalStore).institutionalFilter.dt_fim_vigencia) = $event)),
                                  mask: "DD/MM/YYYY",
                                  minimal: "",
                                  color: "globalAppPrimaryColor"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_14, [
                                      _createVNode(ButtonCloseModal)
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createVNode(_component_c_q_separator, { class: "q-pt-sm q-pb-lg" }),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_c_q_btn, {
                    id: "btn-clear-filter",
                    propBtnLabel: "Limpar Filtros",
                    propBtnFunction: onClearFilterBtnClick,
                    propBtnTransparent: true,
                    propBtnSize: _unref(EnumButtonSizes).LARGE_1
                  }, null, 8, ["propBtnSize"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_c_q_btn, {
                    id: "btn-fetch-campaigns",
                    style: {"width":"100%"},
                    propBtnLabel: "Buscar",
                    propBtnFunction: onFetchInstitutionalBtnClick,
                    propBtnTransparent: false,
                    propBtnSize: _unref(EnumButtonSizes).LARGE_1
                  }, null, 8, ["propBtnSize"])
                ]),
                _createVNode(_component_q_inner_loading, {
                  showing: _unref(pagesUtilStore).showLoadingModal,
                  label: "aguarde..."
                }, null, 8, ["showing"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})